import * as React from 'react';
import RequirementsTreeView from '../views/RequirementsTreeView';

// The Requirements page fills the AppShell content slot. The breadcrumb lives in
// the top bar (mockup), so there is no in-content header here — the tree/detail/
// assistant columns (RequirementsTreeView) span the full content area.
export default function MainGrid() {
  return <RequirementsTreeView />;
}
